import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from '../Tooltip/Tooltip';
export const DisabledOverlay = ({ id, active, tooltipMsg, children, }) => {
    return (_jsxs("div", { id: id, className: `relative transition-opacity ${active ? 'opacity-[0.4]' : ''}`, children: [active && (_jsx(Tooltip, { text: tooltipMsg, followMouse: true, children: _jsx("div", { className: "absolute z-30 h-full w-full" }) })), children] }));
};
//# sourceMappingURL=DisabledOverlay.js.map